import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=bd1b8faa&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=bd1b8faa&prod&lang=less&scoped=true"
import style1 from "./Info.vue?vue&type=style&index=1&id=bd1b8faa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1b8faa",
  null
  
)

export default component.exports